<template>
  <div class="editor-page idee">
    <loader v-if="item==null" :show="item==null" :width="40" :height="40"></loader>
    <top-bar
      v-if="item!=null"
      :title="id=='new' ? 'Inserimento Località' : 'Modifica Località'"
      :preview="item.contents[lang].permalink + '?preview=1'"
      :action="`Salva`"
      :actionIsValid="isValid"
      :loading="loading || item==null"
      @lang="(l) => { lang = l; $v.$touch(); }"
      @onAction="save"
    ></top-bar>
    <div v-if="item && item.draft > 0">
      <div class="alert alert-info alert-with-icon">
        <button type="button" aria-hidden="true" class="close">×</button>
        <span data-notify="icon" class="ti-bell"></span>
        <span data-notify="message">Scheda BOZZA di Revisione</span>
      </div>
    </div>
    <form class="form row" v-if="item!=null">
      <div class="col-md-9">
        <card title="Informazioni di base" :collapse="false">
          <content>
            <div class="form-group">
              <label>Denominazione</label>
              <input
                type="text"
                required="true"
                class="input form-control"
                aria-required="true"
                aria-invalid="false"
                v-model="item.contents[lang].DENOMINAZIONE"
              />
            </div><!-- denominazione -->
            <div class="form-group">
              <label>Slug</label>
              <input
                type="text"
                class="input form-control"
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].slug"
              />
            </div><!-- slug -->
            <div class="form-group">
              <label>Distanza dal capoluogo</label>
              <input
                type="text"
                class="input form-control"
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].DISTANZACAPOL"
              />
            </div><!-- distanza dal capoluogo -->
            <div class="form-group">
              <label>Dove si trova</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].DOVESITROVA"
              />
            </div><!-- dove si trova -->
            <div class="form-group">
              <label>Perché</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].PERCHE"
              />
            </div><!-- perché -->
            <div class="form-group">
              <label>Quando</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].QUANDO"
              />
            </div><!-- quando -->
            <div class="form-group">
              <label>Camera Con</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].CAMERACON"
              />
            </div><!-- camera con -->
            <div class="form-group">
              <label>Da non perdere</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].DANONPERDERE"
              />
            </div><!-- da non perdere -->
            <div class="form-group">
              <label>Cosa mangiare</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].SULLATAVOLA"
              />
            </div><!-- cosa mangiare / SULLATAVOLA -->
            <div class="form-group">
              <label>Divertimento</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].DIVERTIRSI"
              />
            </div><!-- divertimento / DIVERTIRSI -->
            <div class="form-group">
              <label>Come tenersi in forma</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].INFORMA"
              />
            </div><!-- come tenersi in forma -->
            <div class="form-group">
              <label>Appuntamenti</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].APPUNTAMENTI"
              />
            </div><!-- appuntamenti -->
            <div class="form-group">
              <label>Informazioni</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].INFORMAZIONI"
              />
            </div><!-- informazioni / -->
            <div class="form-group">
              <label>Nei dintorni</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].NEIDINTORNI"
              />
            </div><!-- nei dintorni / NEIDINTORNI -->
            <div class="form-group">
              <label>Note</label>
              <rich-editor
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].NOTE"
              />
            </div><!-- note -->
            <fieldset>
              <h5>SEO</h5>
              <textbox
                title="Keywords"
                v-model="item.contents[ lang ].google.keywords"
              />
              <textbox
                title="Titolo Google"
                v-model="item.contents[ lang ].google.title"
              />
              <a-textarea
                title="Descrizione Google"
                :maxLength="160"
                v-model="item.contents[ lang ].google.description"
              />
            </fieldset>
            <fieldset>
              <h5>Social</h5>
              <textbox
                title="Titolo Account Social"
                v-model="item.contents[ lang ].social.title"
              />
              <a-textarea
                title="Descrizione Account Social"
                :maxLength="160"
                v-model="item.contents[ lang ].social.description"
              />
            </fieldset>
            <hr/>
            <card title="Punto Arrivo Itinerari Google Directions/Transit" :collapse="false">
              <address-box v-model="item.location"></address-box>
            </card><!-- indirizzo -->
            <card title="Immagini" :collapse="false">
              <attachments-box v-model="item.attachments"></attachments-box>
            </card><!-- immagini -->
          </content>
        </card>
      </div>
      <div class="col-md-3"><!-- SIDEBAR DX -->
        <card title="Impostazioni">
         <statuses-box ref="sbox"  :lang="lang" :entity="item.id" v-model="item.contents[ lang ].status" title=false></statuses-box><!-- stato -->
          <author-box v-model="item.contents[lang].author"></author-box><!-- autore -->
        </card><!-- impostazioni -->
        <card title="Altro">
          <fieldset>
            <h5>Altitudine</h5>
            <category-box :mainCategory="3" v-model="item.fascia_altimetrica"></category-box>
          </fieldset>
          <hr/>
          <fieldset>
            <destination-box
              v-model="item.destinazione"
              category-name="Destinazione"
            >
            </destination-box><!-- destinazione -->
          </fieldset>
          <hr/>
          <fieldset>
            <h5>Comune</h5>
            <city-combo v-model="item.comune" :province_id=0></city-combo>
          </fieldset><!-- comune -->
        </card><!-- Altro -->
        <card title="I.A.T.">
          <i-a-t-combo
            required="true"
            aria-required="true"
            aria-invalid="false"
            v-model="item.iat"
          />
        </card><!-- IAT -->

      </div><!-- ./SIDEBAR DX -->
    </form>
  </div>
</template>

<script>
  import axios from "axios";
  import RichEditor from "@/components/altrama/RichEditor";
  import TagManager from "@/components/altrama/TagManager";
  import CategoryCombo from "@/components/altrama/CategoryCombo";
  import AuthorBox from "@/components/altrama/AuthorBox";
  import StatusesBox from "@/components/altrama/StatusesBox";
  import DatePicker from "@/components/altrama/DatePicker";
  import AttachmentsBox from "@/components/altrama/AttachmentsBox";
  import TopBar from "@/components/altrama/TopBar";
  import CityCombo from "@/components/altrama/CityCombo";
  import ContactsEditor from "@/components/altrama/ContactsEditor";
  import AddressBox from "@/components/altrama/AddressBox";
  import IATCombo from "@/components/altrama/IATCombo";
  import CategoryBox from "@/components/altrama/CategoryBox";
  import Textbox from "@/components/altrama/form/Textbox";
  import ATextarea from "@/components/altrama/form/ATextarea";
  import DestinationBox from "@/components/altrama/DestinationBox";

  import {validationMixin} from "vuelidate";
  import {required} from "vuelidate/lib/validators";

  export default {
    components: {
      RichEditor,
      TagManager,
      CategoryCombo,
      AuthorBox,
      StatusesBox,
      DatePicker,
      AttachmentsBox,
      TopBar,
      CityCombo,
      ContactsEditor,
      AddressBox,
      IATCombo,
      CategoryBox,
      Textbox,
      ATextarea,
      DestinationBox
    },
    props: ["id"],
    mixins: [validationMixin],
    validations() {
      if (
        !!this.item &&
        !!this.item.contents[this.lang] &&
        this.item.contents[this.lang].status == 1
      ) {
        return {
          item: {
            contents: this.$contentTemplate({
              title: {required},
              description: {required},
              excerpt: {required},
              slug: {required},
            })
          }
        };
      }
      return {
        item: {
          contents: this.$contentTemplate({
            title: {required},
            description: "",
            excerpt: "",
            google: {description: "", keywords: "", title: ""},
            slug: "",
            social: {description: "", title: ""},
            subtitle: ""
          })
        }
      };
    },

    data() {
      return {
        needSave: false,
        hasErrors: false,
        loading: true,
        item: null,
        lang: "it"
      };
    },

    computed: {
      isValid: function () {
        if (!this.item.canSave) {
          return this.item.contents[this.lang].status !== 1
        }
        return true
      },
      template: function () {
        const currentUserId = Number(this.$api.user.current().id);
        return {
          id: "new",
          contents: this.$contentTemplate({
            APPUNTAMENTI: "",
            CAMERACON: "",
            DANONPERDERE: "",
            DENOMINAZIONE: "",
            DISTANZACAPOL: "",
            DIVERTIRSI: "",
            DOVESITROVA: "",
            INFORMA: "",
            INFORMAZIONI: "",
            NEIDINTORNI: "",
            NOTE: "",
            PERCHE: "",
            QUANDO: "",
            SULLATAVOLA: "",
            google: {description: "", keywords: "", title: ""},
            slug: "",
            social: {description: "", title: ""},
            permalink: "",
            author: currentUserId,
            status: 2,
            pub_date: ""
          }),
          fascia_altimetrica: null,
          attachments: [],
          destinazione: null,
          iat: [],
          location: {},
          comune: null,
          canSave: false,
          created_at: ""
        };
      }
    },
    methods: {
      save: _.debounce(function () {
        this.$v.$touch();
        if (!this.$v.item.contents[this.lang].$anyError) {
          let self = this;
          let url = `${self.$url}localita-ert/${self.id}`;
          let method = "put";

          if (this.item.id == "new") {
            method = 'post';
            url = `${self.$url}localita-ert`;
          }

          this.item.lang = this.lang;
          this.loading = true;

          axios({
            method: method,
            url: url,
            headers: this.$config.axiosHeaders(),
            data: this.item
          })
            .then(function (response) {
              self.loading = false;
              self.$notifyVue(
                "top",
                "center",
                response.data.status,
                response.data.data.message,
                "ti-check"
              );
              self.$refs.sbox.update();
              self.item.contents[self.lang].permalink = response.data.data.permalink + '?preview=1';

              if (response.data.data.id !== self.item.id) {
                self.item.id = response.data.data.id;
                self.$router.push({params: {id: self.item.id}})
              }
            })
            .catch(function (error) {
              self.loading = false;
              self.hasErrors = true;
              self.$processError(error);
              
            });

          this.needSave = false;
        }
     
      }, 300),
      async loadData() {
        let self = this;
        self.item = null;

        if (this.item && this.id == this.item.id) {
          console.log("Ricaricamento della stessa pagina");
          return;
        }

        if (this.id == "new") {
          self.item = JSON.parse(JSON.stringify(self.template));
          self.needSave = false;
          self.loading = false;
          return;
        }

        self.loading = true;

        await axios({
          method: "get",
          url: `${self.$url}localita-ert/${self.id}`,
          headers: this.$config.axiosHeaders()
        })
          .then(function (response) {
            self.item = _.merge(JSON.parse(JSON.stringify(self.template)), response.data.data);
            self.needSave = false;
            self.loading = false;
          })
          .catch(function (error) {
            self.loading = false;
            self.hasErrors = true;
            self.$processError(error);
            
          });
      }
    },
    mounted: function () {
      this.loadData();
    },
    watch: {
      id: {
        handler(val, oldVal) {
           if(oldVal!=val && val=="new")
                    location.reload();
        },
        deep: true
      }
    },
  };
</script>

